import { NgModule } from '@angular/core';
import { MaskDirective } from './mask/mask';
import { MaskCurrencyDirective } from './mask-currency/mask-currency';
@NgModule({
	declarations: [MaskDirective,
    MaskCurrencyDirective],
	imports: [],
	exports: [MaskDirective,
    MaskCurrencyDirective]
})
export class DirectivesModule {}



// WEBPACK FOOTER //
// D:/desv/producao/ITN/srvHCWaba/src/directives/directives.module.ts